// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fu","advertDetailParameterList__header":"c-q_fv","advertDetailParameterList__list":"c-q_fw"};